// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ec081d8a","239":"e107985d","455":"62490e94"}[chunkId] + ".chunk.js";
};